import { render, staticRenderFns } from "./document.template?vue&type=template&id=6355b39b&scoped=true&lang=pug&"
import script from "./document.client?vue&type=script&lang=ts&"
export * from "./document.client?vue&type=script&lang=ts&"
import style0 from "./document.style?vue&type=style&index=0&id=6355b39b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6355b39b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6355b39b')) {
      api.createRecord('6355b39b', component.options)
    } else {
      api.reload('6355b39b', component.options)
    }
    module.hot.accept("./document.template?vue&type=template&id=6355b39b&scoped=true&lang=pug&", function () {
      api.rerender('6355b39b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/attachments/viewer/document/document.component.vue"
export default component.exports